import styled from "styled-components";

const Flex = styled.div`
  display: flex;
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
`;

Flex.defaultProps = {
  justifyContent: "initial",
  alignItems: "initial",
};

export default Flex;
